import { Body2, Caption } from '@backoffice-frontend/patterns'
import { CheckCircleSolidIcon, XCircleSolidIcon } from '@moia-dev/pace-icons'
import { Badge } from '@moia-dev/pace-web'
import { useTranslation } from 'react-i18next'

export const VehicleDrawerStatusBarRow = ({
  title,
  subtitle,
  isOnline,
}: {
  title: string
  subtitle: string
  isOnline: boolean
}) => {
  const { t } = useTranslation()

  return (
    <>
      <Body2>{title}</Body2>
      {isOnline ? (
        <Badge
          label={t('common_online_label')}
          icon={<CheckCircleSolidIcon />}
          variant={'success'}
        />
      ) : (
        <Badge
          label={t('common_offline_label')}
          icon={<XCircleSolidIcon />}
          variant={'critical'}
        />
      )}
      <Caption color="textSecondary">{subtitle}</Caption>
    </>
  )
}
